import { NavLink } from "react-router-dom";
import { 
  LayoutDashboard, 
  Image, 
  Newspaper, 
  Building2, 
  Scale, 
  Search, 
  ShieldCheck, 
  GraduationCap, 
  Link2,
  HelpCircle // 1. Importando o ícone para o FAQ
} from "lucide-react";
import "./Sidebar.css";

export default function Sidebar() {
  return (
    <div className="sidebar">
      <div className="sidebar-header">
        <LayoutDashboard className="sidebar-logo-icon" size={24} />
        <h2 className="sidebar-title">Painel</h2>
      </div>

      <div className="sidebar-section">
        <h4>Site</h4>
        <ul>
          <li>
            <NavLink to="/" className={({ isActive }) => isActive ? "active" : ""}>
              <LayoutDashboard size={18} /> Inicio
            </NavLink>
          </li>
          <li>
            <NavLink to="/banners" className={({ isActive }) => isActive ? "active" : ""}>
              <Image size={18} /> Banners
            </NavLink>
          </li>
          <li>
            <NavLink to="/noticias" className={({ isActive }) => isActive ? "active" : ""}>
              <Newspaper size={18} /> Notícias
            </NavLink>
          </li>
          <li>
            <NavLink to="/institucional" className={({ isActive }) => isActive ? "active" : ""}>
              <Building2 size={18} /> Institucional
            </NavLink>
          </li>
          <li>
            <NavLink to="/governanca" className={({ isActive }) => isActive ? "active" : ""}>
              <Scale size={18} /> Governança Corporativa
            </NavLink>
          </li>
          <li>
            <NavLink to="/transparencia" className={({ isActive }) => isActive ? "active" : ""}>
              <Search size={18} /> Transparência
            </NavLink>
          </li>
          <li>
            <NavLink to="/controles" className={({ isActive }) => isActive ? "active" : ""}>
              <ShieldCheck size={18} /> Controles Internos
            </NavLink>
          </li>
          <li>
            <NavLink to="/educacao" className={({ isActive }) => isActive ? "active" : ""}>
              <GraduationCap size={18} /> Educação Previdenciária
            </NavLink>
          </li>
          <li>
            <NavLink to="/acesso-rapido" className={({ isActive }) => isActive ? "active" : ""}>
              <Link2 size={18} /> Acesso Rápido
            </NavLink>
          </li>
          
          {/* 2. ADICIONANDO O BOTÃO DO FAQ AQUI */}
          <li>
            <NavLink to="/faq" className={({ isActive }) => isActive ? "active" : ""}>
              <HelpCircle size={18} /> FAQ
            </NavLink>
          </li>
        </ul>
      </div>
    </div>
  );
}